import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SlotModule } from "@vattenfall/core";

import { StaticLoadingElement } from "./static-loading.element";

@NgModule({
  imports: [
    /**
     * Make sure all the dependencies that this element needs are declared as imports,
     * the only exception is the `HttpClientModule`. This should always be declared once
     * and never again.
     */
    CommonModule,
    SlotModule,
  ],
  declarations: [StaticLoadingElement],
  /**
   * Make sure to include the element in the bootstrap array.
   * This will instruct the `ElementsModule` to instantiate the element as a custom elements.
   */
  bootstrap: [StaticLoadingElement],
  exports: [StaticLoadingElement],
})
export class StaticLoadingModule {}
